import axios, { endPoints } from 'utils/api';

const SET_LIST = 'questions/SET_LIST';
const SET_DETAIL = 'questions/SET_DETAIL';
const SET_VERSION_HISTORY = 'questions/SET_VERSION_HISTORY';
const SET_LOADING = 'questions/SET_LOADING';
const SET_ERROR = 'questions/SET_ERROR';
const UPSERT = 'questions/UPSERT';
const REMOVE_FROM_LIST = 'questions/REMOVE_FROM_LIST';

export const setQuestionsList = (data) => ({ type: SET_LIST, data });
export const setQuestionDetail = (data) => ({ type: SET_DETAIL, data });
export const setQuestionVersionHistory = (questionId, versions) => ({
    type: SET_VERSION_HISTORY, questionId, versions
});
export const setQuestionsLoading = (loading) => ({ type: SET_LOADING, loading });
export const setQuestionsError = (error) => ({ type: SET_ERROR, error });
export const upsertQuestion = (data) => ({ type: UPSERT, data });
export const removeQuestionFromList = (questionId) => ({ type: REMOVE_FROM_LIST, questionId });

const INITIAL_STATE = {
    list: [],
    listLoading: false,
    listError: null,
    detail: {},
    versionHistory: {}
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_LIST:
            return { ...state, list: [...action.data], listError: null };

        case SET_DETAIL: {
            const key = `${action.data.id}:${action.data.version}`;

            return { ...state, detail: { ...state.detail, [key]: action.data } };
        }

        case SET_VERSION_HISTORY:
            return {
                ...state,
                versionHistory: { ...state.versionHistory, [action.questionId]: [...action.versions] }
            };

        case SET_LOADING:
            return { ...state, listLoading: action.loading };

        case SET_ERROR:
            return { ...state, listError: action.error, listLoading: false };

        case UPSERT: {
            const existingIdx = state.list.findIndex((q) => q.id === action.data.id);
            const nextList = existingIdx >= 0
                ? state.list.map((q, i) => i === existingIdx ? action.data : q)
                : [...state.list, action.data];

            return { ...state, list: nextList };
        }

        case REMOVE_FROM_LIST:
            return { ...state, list: state.list.filter((q) => q.id !== action.questionId) };

        default:
            return state;
    }
}

export const fetchQuestions = (params = {}) => async (dispatch) => {
    dispatch(setQuestionsLoading(true));

    try {
        const response = await axios.get(endPoints.questions, { params });

        dispatch(setQuestionsList(response.data.data));
    } catch (error) {
        dispatch(setQuestionsError(error.message || 'Failed to load questions'));
    } finally {
        dispatch(setQuestionsLoading(false));
    }
};

export const createQuestion = (body) => async (dispatch) => {
    const response = await axios.post(endPoints.questions, body);

    dispatch(upsertQuestion(response.data));
    dispatch(setQuestionDetail(response.data));

    return response.data;
};

export const createQuestionVersion = (questionId, body) => async (dispatch) => {
    const response = await axios.post(`${endPoints.questions}/${questionId}/versions`, body);

    dispatch(upsertQuestion(response.data));
    dispatch(setQuestionDetail(response.data));

    return response.data;
};

export const archiveQuestionVersion = (questionId, version) => async (dispatch) => {
    const response = await axios.patch(
        `${endPoints.questions}/${questionId}/versions/${version}/status`,
        { status: 'archived' }
    );

    dispatch(setQuestionDetail(response.data));

    return response.data;
};

export const fetchQuestionVersionHistory = (questionId) => async (dispatch) => {
    const response = await axios.get(`${endPoints.questions}/${questionId}/versions`);

    dispatch(setQuestionVersionHistory(questionId, response.data.data));

    return response.data.data;
};
